import React, { useLayoutEffect, useRef, useState } from "react";

// import rotation_image from "./resources/images/World-Flags.png"
// import rednetwork from "./resources/images/rednetwork_yellowred.png"
// import rotation_image from "./resources/images/rednetwork.png"
import rotation_image2 from "../../resources/images/rednetwork2.png";
import rotation_image3 from "../../resources/images/rednetwork3.png";


const GlobalStyles = () => (
    // <style jsx global>{`
    <style>{`
    @keyframes spin         { from { transform: rotate(0deg); }     to { transform: rotate(360deg); } }
    @keyframes counterSpin  { from { transform: rotate(0deg); }     to { transform: rotate(-360deg); } }
    @keyframes breathe      { 0%, 100% { opacity: 0.95; } 50% { opacity: 1; } }

    .worldmap-layer { will-change: transform; }

    @media (prefers-reduced-motion: reduce) {
        .worldmap-layer { animation: none !important; }
    }
  `}</style>
);

// Beautiful safe palette: cyan → blue → violet → purple → magenta hint → back to cyan
// " #00f7ff, #00d0ff, #5e3bff, #8a2be2, #a100ff, #00eaff, #0080ff
const colors = ['#00f7ff', '#00d0ff', '#5e3bff', '#8a2be2', '#a100ff', '#00eaff', '#0080ff'];


const WorldMap2 = ({ paused = false }) => {
    // randomize starting color but keep same cycle
    const startIndex = Math.floor(Math.random() * colors.length);
    const rotatedColors = [...colors.slice(startIndex), ...colors.slice(0, startIndex)];
    const gradientJSX = `linear-gradient(45deg, ${rotatedColors.join(', ')})`;

    // Capture the live computed transform/opacity the moment we pause, so we
    // can hold the layers at their current rotation instead of snapping back
    // to the base angle when the animation is removed. useLayoutEffect runs
    // synchronously before paint, so we can read the animated values while
    // the animation is still running (first paused render keeps it running),
    // then swap to the frozen static state on the next render — no snap.
    const layer1Ref = useRef(null);
    const layer2Ref = useRef(null);
    const [frozen, setFrozen] = useState(null);

    useLayoutEffect(() => {
        if (paused && !frozen && layer1Ref.current && layer2Ref.current) {
            const c1 = getComputedStyle(layer1Ref.current);
            const c2 = getComputedStyle(layer2Ref.current);
            setFrozen({
                layer1: {
                    transform: c1.transform && c1.transform !== "none" ? c1.transform : "translateZ(0) rotate(65deg)",
                    opacity: c1.opacity,
                },
                layer2: {
                    transform: c2.transform && c2.transform !== "none" ? c2.transform : "translateZ(0)",
                    opacity: c2.opacity,
                },
            });
        }
    }, [paused, frozen]);

    const layer1Anim = paused && frozen ? "none" : "spin 90s linear infinite, breathe 7s ease-in-out infinite";
    const layer2Anim = paused && frozen ? "none" : "counterSpin 140s linear infinite, breathe 7s ease-in-out -3.5s infinite";
    const layer1Transform = paused && frozen ? frozen.layer1.transform : "translateZ(0) rotate(65deg)";
    const layer2Transform = paused && frozen ? frozen.layer2.transform : "translateZ(0)";
    const layer1Opacity = paused && frozen ? frozen.layer1.opacity : undefined;
    const layer2Opacity = paused && frozen ? frozen.layer2.opacity : undefined;

    return (<>
        <GlobalStyles />

        <div
            style={{
                position: "relative",
                width: "100%",
                maxWidth: "min(800px, 70vh)",
                aspectRatio: "1",
                margin: "0 auto",
                background: "transparent",
            }}
        >
            {/* Layer 1 – rotating */}
            <div
                ref={layer1Ref}
                className="worldmap-layer"
                style={{
                    position: "absolute",
                    inset: 0,
                    // background: gradientJSX,
                    backgroundImage: gradientJSX,
                    backgroundSize: "400% 400%",
                    // backgroundAttachment: "fixed",  // removed: forces repaint each frame
                    animation: layer1Anim,
                    transform: layer1Transform,
                    opacity: layer1Opacity,
                    maskImage: `url(${rotation_image2})`,
                    maskSize: "contain",
                    maskRepeat: "no-repeat",
                    maskPosition: "center",
                    WebkitMaskImage: `url(${rotation_image2})`,
                    WebkitMaskSize: "contain",
                    WebkitMaskRepeat: "no-repeat",
                    WebkitMaskPosition: "center",
                    pointerEvents: "none",
                }}
            />

            {/* Layer 2 – counter-rotating or static */}
            <div
                ref={layer2Ref}
                className="worldmap-layer"
                style={{
                    position: "absolute",
                    inset: 0,
                    // background: gradientJSX,
                    backgroundImage: gradientJSX,
                    backgroundSize: "400% 400%",
                    // backgroundAttachment: "fixed",  // removed: forces repaint each frame
                    animation: layer2Anim,
                    transform: layer2Transform,
                    opacity: layer2Opacity,
                    maskImage: `url(${rotation_image3})`,
                    maskSize: "contain",
                    maskRepeat: "no-repeat",
                    maskPosition: "center",
                    WebkitMaskImage: `url(${rotation_image3})`,
                    WebkitMaskSize: "contain",
                    WebkitMaskRepeat: "no-repeat",
                    WebkitMaskPosition: "center",
                    pointerEvents: "none",
                }}
            />
        </div>
    </>);
};

export default WorldMap2;
